<template>
<transition
@before-enter="beforeEnter"
@enter="enter"
@after-enter="afterEnter"
@before-leave="beforeLeave"
@leave="leave"
@after-leave="afterLeave"
>
<div v-show="isShow" class="c-modal" :class="[`c-modal--${currentPoloID}`, currentSlideID]">
  <div class="c-modal__bg" @click="close"></div>
  <div class="c-modal__wrap">
    <div class="p-item">
      <div class="p-item__head">
        <h2>{{ currentPoloID }}</h2>
        <button class="c-btnClose" @click="close">
          <span></span>
        </button>
      </div>
      <div ref="p-item__body" class="p-item__body">
        <div class="swiper">
          <ul ref="is-photo" class="is-photo swiper-wrapper">
            <li class="swiper-slide"><img :src="`/special/tenkyu/10color/assets/img/cap/${currentPoloID}.png`" alt="" width="" height=""></li>
            <li class="swiper-slide"><img :src="`/special/tenkyu/10color/assets/img/visor/${currentPoloID}.png`" alt="" width="" height=""></li>
            <li class="swiper-slide"><img :src="`/special/tenkyu/10color/assets/img/shorts/${currentPoloID}.png`" alt="" width="" height=""></li>
            <li class="swiper-slide"><img :src="`/special/tenkyu/10color/assets/img/skirt/${currentPoloID}.png`" alt="" width="" height=""></li>
            <li class="swiper-slide"><img src="/special/tenkyu/10color/assets/img/bag/item.png" alt="" width="" height=""></li>
          </ul>
        </div>
        <ul class="is-info">
          <li>{{ itemName }}</li>
          <li><a :href="itemURL" target="_blank">{{ itemInfo }}</a></li>
        </ul>
      </div>
      <div class="p-item__list">
        <ul>
          <li @click="slideTo(0)"><img :src="`/special/tenkyu/10color/assets/img/cap/${currentPoloID}.png`" alt="" width="70" height="70"></li>
          <li @click="slideTo(1)"><img :src="`/special/tenkyu/10color/assets/img/visor/${currentPoloID}.png`" alt="" width="70" height="70"></li>
          <li @click="slideTo(2)"><img :src="`/special/tenkyu/10color/assets/img/shorts/${currentPoloID}.png`" alt="" width="70" height="70"></li>
          <li @click="slideTo(3)"><img :src="`/special/tenkyu/10color/assets/img/skirt/${currentPoloID}.png`" alt="" width="70" height="70"></li>
          <li @click="slideTo(4)"><img src="/special/tenkyu/10color/assets/img/bag/item.png" alt="" width="70" height="70"></li>
        </ul>
      </div>
    </div>
  </div>
</div>
</transition>
</template>

<script>
import { ITEM_DATA } from '@/_constant/common.js';
import Swiper from 'swiper';
import { gsap, Power3 } from 'gsap/gsap-core';

export default {
  data() {
    return { 
      swiper: null,
      currentSlideID: '',
      itemName: '',
      itemInfo: '',
      itemURL: '',
    }
  },
  computed: {
    currentPoloID() {
      return this.$store.getters.currentPoloID;
    },
    isShow() {
      return this.$store.getters.isShowModal;
    },
  },
  watch: {
    isShow(isNew, isOld) {
      if (isNew) {
        this.setting();
      }
    },
  },
  mounted() {
  },
  methods: {
    setting() {
      this.swiper = new Swiper(this.$refs['p-item__body'].querySelector('.swiper'), {
        speed: 400,
        on: {
          init: () => {
            this.currentSlideID = 'c-modal--slide-1';
            this.itemName = ITEM_DATA[0][0];
            this.itemInfo = ITEM_DATA[0][1];
          }
        }
      });
    },
    reset() {
      this.swiper.destroy();
      this.swiper = null;
    },
    close() {
      this.$store.commit('setShowModal', false);
    },
    slideTo(num) {
      this.currentSlideID = `c-modal--slide-${num + 1}`;
      this.itemName = ITEM_DATA[num][0];
      this.itemInfo = ITEM_DATA[num][1];
      this.itemURL = ITEM_DATA[num][2];
      this.swiper.slideTo(num);
    },

    // transition
    beforeEnter() {
    },
    enter(el, done) {        
      const bg = el.querySelector('.c-modal__bg');
      const wrapper = el.querySelector('.c-modal__wrap');

      const tl = gsap.timeline({
        onComplete: () => {
          done();
        }
      });

      tl.fromTo(bg, {
        opacity: 0
      }, {
        duration: 1.0,
        opacity: 1,
        ease: Power3.easeOut
      })
      .fromTo(wrapper, {
        x: '110%',
      }, {
        duration: 1.0,
        x: '0%',
        ease: Power3.easeOut
      }, 0.1);
    },
    afterEnter() {
    },

    beforeLeave() {
    },
    leave(el, done) {
      const bg = el.querySelector('.c-modal__bg');
      const wrapper = el.querySelector('.c-modal__wrap');

      const tl = gsap.timeline({
        onComplete: () => {
          done();
        }
      });

      tl.to(wrapper, {
        duration: 1.0,
        x: '110%',
        ease: Power3.easeIn
      })
      .to(bg, {
        duration: 1.0,
        opacity: 0,
        ease: Power3.easeIn
      }, 0.1);
    },
    afterLeave() {
      this.reset();
    }
  }
}
</script>